import {DecimalPipe} from '@angular/common'
import {Component, inject, OnInit, signal} from '@angular/core'
import {KalpResult} from '../../model/kalp-result'
import {KalpService, LegacyKalp} from '../../services/kalp.service'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'
import {EPieChartComponent} from './e-chart/e-pie-chart.component'

@Component({
  selector: 'spb-piechart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
  imports: [
    DecimalPipe,
    EPieChartComponent
  ]
})
export class PieChartComponent implements OnInit {

  public readonly kalps = signal<KalpResult[]>([])

  private readonly kalpService = inject(KalpService)


  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  public ngOnInit(): void {
    this.kalpService.kalpResult$
      .pipe(this.takeUntilDestroyed())
      .subscribe((kalps: LegacyKalp[]) => {
        this.kalps.set(kalps.map((k: LegacyKalp) => new KalpResult(k)))
      })
  }
}

